<script>
/* Mixin for collecting and setting up console logs debug in app pages  */

// Number of lines to keep in the logs. Other lines will be deleted.
const MAX_NUM_OF_LINES = 200;
export default {
    name: 'ConsoleLogsMixin',
    props: {
        /***********************************
         * Props affecting input component.*
         **********************************/
        text: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    mounted() {
        function formatLogs(text) {
            const myArray = text.split('<br> ', MAX_NUM_OF_LINES);
            return myArray.join('<br> ');
        }
        if (this.$q.platform.is.mobile) {
            console.log = (function (old_function, div_log) {
                return function (...args) {
                    // Use rest parameter to capture all arguments
                    old_function(...args); // Pass all arguments to the original console.log
                    let text = args
                        .map(arg =>
                            typeof arg === 'object'
                                ? JSON.stringify(arg)
                                : String(arg)
                        )
                        .join(' ');
                    text = text + '<br> ' + div_log.innerHTML;
                    div_log.innerHTML = formatLogs(text);
                };
            })(console.log.bind(console), this.$refs['error-log']);
            console.error =
                console.debug =
                console.info =
                console.warn =
                    console.log;
        }
    },
    data() {
        return {};
    }
};
</script>
